$(document).ready(function () {
  // Initialize product-slider slick


  // Initialize slick03
  $('.slick03').slick({
    autoplay: true,
    autoplaySpeed: 1500,
    speed: 1500,
    infinite: true,
    dots: true,
    arrows: false,
    centerMode: true,
    centerPadding: "7%",
    pauseOnFocus: false,
    pauseOnHover: false,
    pauseOnDotsHover: false
  });

  // Ensure autoplay continues after touchmove for slick03
  $('.slick03').on('touchmove', function() {
    $(this).slick('slickPlay');
  });
});

$(document).ready(function () {
  // Initialize product-slider slick

// Initialize slick04
$('.slick04').slick({
  slidesToShow: 3, // 3枚を横並びに表示
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 1500,
  speed: 1500,
  infinite: true,
  dots: false,
  arrows: false,
  centerMode: false, // 中央揃えを無効
  centerPadding: "0", // パディングなし
  pauseOnFocus: false,
  pauseOnHover: false,
  pauseOnDotsHover: false
});


  // Ensure autoplay continues after touchmove for slick03
  $('.slick03').on('touchmove', function() {
    $(this).slick('slickPlay');
  });
});

